import Vue from "vue";
import moment from "moment";
import axios from "axios";

export default {
  name: "ActivityReadings",
  components: {
    ReadingComp: require("../../../../components/reading.vue").default,
    CameraComp:
      require("@/components/uploadPictureToActivityAttachment/uploadPictureToActivityAttachment.vue")
        .default,
  },
  props: {
    dataObj: {
      type: Object,
      required: true,
    },
    isOffline: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      displayCamera: false,
      //readings: [],
      //origCurReadings: [],
      //readOnly: false,
      //isAllowChangeDate: false,
      //curReadingSource: {}
    };
  },
  created() {
    this.$root.$on("picture_not_uploaded_get_meter_readings", () => {
      this.displayCamera = true;
      setTimeout(() => (this.displayCamera = false), 500);
    });
    //console.log("readings data", this.dataObj.readings[0].previousReading.readingDate);

    //this.readings = this.propReadings.item.readings;
    //this.readOnly = this.propReadings.readOnly;
    //this.isAllowChangeDate = this.propReadings.item.isAllowChangeDate;
    ////this.curReadingSource = this.readings[0].currentReading.slice();
    //this.curReadingSource = Object.assign({}, this.readings[0].currentReading);
    //this.readings.forEach(rdg => {
    //  var origRdg = {
    //    clockOver: rdg.curReading.clockOver,
    //    reading: rdg.curReading.reading,
    //    address: rdg.curReading.propertyAddress,
    //    meterId: rdg.curReading.meterId,
    //    meterRef: rdg.curReading.meterRef,
    //    readingDate: rdg.curReading.date,
    //    readingTimeHH: moment(rdg.curReading.date).format('HH'),
    //    readingTimeMin: moment(rdg.curReading.date).format('mm'),
    //    reason: rdg.curReading.readingReason,
    //    reasonDescr: rdg.readingReasonDescription,
    //    isAllowChangeDate: rdg.isAllowChangeDate,
    //    readonly: (rdg.curReading.readonly ? rdg.curReading.readonly: false)
    //  };
    //  this.origCurReadings.push(origRdg);
    //  rdg.curReading.readonly = false;
    //  rdg.curReading.employee = true;
    //  rdg.curReading.isAllowChangeDate = rdg.isAllowChangeDate;
    //  if (rdg.prevReading) {
    //    rdg.prevReading.readonly = true;
    //    rdg.prevReading.employee = true;
    //    rdg.prevReading.isAllowChangeDate = rdg.isAllowChangeDate;
    //    rdg.curReading.prevReading = rdg.prevReading.reading;
    //  }
    //});
  },
  methods: {
    //reset() {
    //  this.readings[0].currentReading = Object.assign({}, this.curReadingSource);
    //  console.log(this.curReadingSource);
    //  console.log(this.readings[0].currentReading);
    //}
    //reset(connId) {
    //  var rdg = this.readings.filter(function (r) { return r.connectionId == connId; })[0];
    //  var origRdg = this.origCurReadings.filter(function (r) { return r.connectionId == connId; })[0];
    //  rdg.clockOver = origRdg.clockOver;
    //  rdg.reading = origRdg.reading;
    //  rdg.readingDate = origRdg.readingDate;
    //  rdg.curReading.readingReason = origRdg.reason;
    //  rdg.readingReasonDescription = origRdg.reasonDescr;
    //},
  },
};
